module.exports = __webpack_public_path__ + "static/img/partner_17.f47c5ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_17.png
// module id = lS/B
// module chunks = 0